module.exports = __webpack_public_path__ + "static/img/M-4.8119626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgaofu/M-4.png
// module id = Gw2O
// module chunks = 0